<template>
  <div class="bg-f8f8f8 pt-20 relative">
    <div class="absolute bg-design2 mob-hidden main-auto">
      <img src="@/views/admin/layouts/image/Polygon 9.svg" alt="bg-polygon" />
    </div>

    <div class="lg:px-8 md:px-8 px-5 pt-8">
      <div class="md:flex">
        <div
          class="md:w-1/5 zindex-1 w-full h-100vh cust-overflow-y-primary-color-grey bg-white rounded-lg"
        >
          <div class="w-full">
            <div>
              <div
                class="cardbody-p rounded-t-lg bg-purple py-4 px-3 sticky z-10 top-0 w-full"
              >
                <!-- @click="handleClick(item)" -->
                <div
                  class="flex items-center"
                  v-for="(item, index) in plan"
                  :key="'item-' + index"
                  :class="{
                    '': item.route === currentRoute.currentRoute.name,
                  }"
                >
                  <div
                    class="rounded-full flex justify-center bg-white items-center"
                  >
                    <feather-icon
                      :icon="item.planicon"
                      class="p-3 icon-size-left"
                      :class="{
                        ' text-primary':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    ></feather-icon>
                  </div>

                  <div class="ml-4">
                    <p
                      class="font-semibold text-base text-white"
                      :class="{
                        ' text-primary':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      {{ item.planname }}
                    </p>
                    <!-- <base-button
                      filled
                      type="success"
                      class="flex py-0-5 px-2 mt-1"
                    >
                       @click="addBanner" 
                      <feather-icon
                        icon="UploadIcon"
                        class="mr-1 h-18w-18"
                      ></feather-icon
                      ><a class="buttontext">Upgrade</a>
                    </base-button> -->
                  </div>
                </div>
              </div>
              <div class="px-2">
                <!-- <div class="rounded-lg mt-4">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer"
                      @click.stop="
                        isCollapseVisibleEcom = !isCollapseVisibleEcom
                      "
                    >
                      <feather-icon
                        icon="ShoppingCartIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">E-commerce</p>
                        </div>
                        <div class="flex my-auto">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleEcom"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleEcom"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in menus"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div> -->

                <!-- <div class="rounded-lg mt-2 py-1">
                  <b-card
                    v-b-toggle.collapse-2
                    no-body
                    class="cardbody-pl hover:bg-gray-50 py-1 border-0"
                  >
                    <div
                      class="flex items-center cursor-pointer"
                      @click.stop="isCollapseVisible = !isCollapseVisible"
                    >
                      <feather-icon
                        icon="ShoppingBagIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Marketplace</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisible"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="px-2"
                    :visible="isCollapseVisible"
                  >
                    <div
                      class="
                        flex
                        items-center
                        cursor-pointer
                        rounded-lg
                        hover:bg-gray-50
                        mt-0-5
                      "
                      v-for="(item, index) in collapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon2"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text2 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div> -->

                <!-- About Page -->
                <div
                  class="rounded-lg mt-2"
                  v-if="
                    userData.role != 'employee' && userData.role != 'leader'
                  "
                >
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisibleAboutUs = !isCollapseVisibleAboutUs
                      "
                    >
                      <img
                        src="../../../assets/images/Admin/dashboard1.png"
                        alt="application"
                        class="pl-3 py-1"
                      />

                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">About Page</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleAboutUs"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>

                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleAboutUs"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in aboutUsCollapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- Application -->
                <div
                  class="rounded-lg mt-2"
                  v-if="userData.role != 'leader' && userData.role != 'intern'"
                >
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisibleApplication =
                          !isCollapseVisibleApplication
                      "
                    >
                      <img
                        src="../../../assets/images/Admin/app.png"
                        alt="application"
                        class="pl-3 py-1"
                      />
                      <!-- <feather-icon
                        icon="BookOpenIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon> -->
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Application</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleApplication"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>

                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleApplication"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in ApplicationCollapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- Campaign -->
                <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisiblecampaign = !isCollapseVisiblecampaign
                      "
                    >
                      <!-- <feather-icon
                        icon="HeartIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon> -->
                      <img
                        src="../../../assets/images/Admin/community1.png"
                        alt="community"
                        class="pl-3 py-1"
                      />
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Campaign</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisiblecampaign"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                          <!-- abc -->
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisiblecampaign"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in campaigncollapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- Coach -->
                <div
                  class="rounded-lg mt-2"
                  v-if="userData.role != 'leader' && userData.role != 'intern'"
                >
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisibleCoach = !isCollapseVisibleCoach
                      "
                    >
                      <img
                        src="../../../assets/images/Admin/mentor.png"
                        alt="caregiver"
                        class="pl-3 py-1"
                      />
                      <!-- <feather-icon
                        icon="BookOpenIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon> -->
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Coach</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleCoach"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>

                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleCoach"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in CoachCollapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- CMS -->
                <div
                  class="rounded-lg mt-2"
                  v-if="userData.role == 'admin' || userData.role == 'intern'"
                >
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisiblepages = !isCollapseVisiblepages
                      "
                      @click="pageCategory"
                    >
                      <img
                        src="../../../assets/images/Admin/pages1.png"
                        alt="page"
                        class="pl-3 py-1"
                      />
                      <!-- <feather-icon
                        icon="FilePlusIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon> -->
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">CMS</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisiblepages"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisiblepages"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in pagescollsapse"
                      :key="'item-' + index"
                      @click="item.text3 !== 'Home' ? handleClick(item) : ''"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                      <b-collapse
                        id="collapse-2"
                        class="bg-white px-2"
                        v-if="item.text3 === 'Home'"
                        :visible="isCollapseVisibleannouncement"
                      >
                        <div
                          class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                          v-for="(item, index) in announcementcollsapse"
                          :key="'item-' + index"
                          @click="handleClick(item)"
                          :class="{
                            'bg-f4f5f6 text-white rounded-lg':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          <feather-icon
                            :icon="item.icon3"
                            class="cursor-pointer p-3 text-primary icon-size-left"
                            :class="{
                              ' text-primary':
                                item.route === currentRoute.currentRoute.name,
                            }"
                          ></feather-icon>
                          <div class="ml-2">
                            <p
                              class="font-semibold text-base"
                              :class="{
                                ' text-primary':
                                  item.route === currentRoute.currentRoute.name,
                              }"
                            >
                              {{ item.text3 }}
                            </p>
                          </div>
                        </div>
                      </b-collapse>
                    </div>
                  </b-collapse>
                </div>
                <!-- Community -->
                <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisiblesocial = !isCollapseVisiblesocial
                      "
                    >
                      <!-- <feather-icon
                        icon="HeartIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon> -->
                      <img
                        src="../../../assets/images/Admin/community1.png"
                        alt="community"
                        class="pl-3 py-1"
                      />
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Community</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisiblesocial"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                          <!-- abc -->
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisiblesocial"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in socialcollapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- Company Dashboard -->
                <div class="rounded-lg mt-2" v-if="userData.role === 'leader'">
                  <b-card
                    no-body
                    @click="showCompanydashboard"
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div class="flex items-center cursor-pointer gap-2">
                      <img
                        src="../../../assets/images/Admin/dashboard1.png"
                        alt="dashboard"
                        class="pl-3 py-1"
                      />
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">
                            Company Dashboard
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="flex items-center cursor-pointer">
                      <feather-icon
                        icon="BookOpenIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">
                            Company Dashboard
                          </p>
                        </div>
                      </div>
                    </div> -->
                  </b-card>
                </div>
                <!-- Corporate Booking -->
                <div
                  class="rounded-lg mt-2"
                  v-if="userData.role != 'leader' && userData.role != 'intern'"
                >
                  <b-card
                    no-body
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                    @click="showCorporatebooking"
                  >
                    <!-- <div class="flex items-center cursor-pointer">
                      <feather-icon
                        icon="BookOpenIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">
                            Corporate Booking
                          </p>
                        </div>
                      </div>
                    </div> -->
                    <div class="flex items-center cursor-pointer gap-2">
                      <img
                        src="../../../assets/images/Admin/booking1.png"
                        alt="booking"
                        class="pl-3 py-1"
                      />
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">
                            Corporate Booking
                          </p>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>
                <!-- Donate -->
                <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    @click="showDonorTable"
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisibledonate = !isCollapseVisibledonate
                      "
                    >
                      <img
                        src="../../../assets/images/donate.png"
                        alt="caregiver"
                        class="pl-3 py-1"
                      />
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Donate</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibledonate"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibledonate"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in donatecollsapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- E-Learning -->
                <div class="rounded-lg mt-2" v-if="userData.role != 'leader'">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisibleElearning = !isCollapseVisibleElearning
                      "
                    >
                      <img
                        src="../../../assets/images/Admin/elearning1.png"
                        alt="service"
                        class="pl-3 py-1"
                      />
                      <!-- <feather-icon
                        icon="BookOpenIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon> -->
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">E-Learning</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleElearning"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>

                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleElearning"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in elearningCollapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- Future Fit Corporate -->
                <div
                  class="rounded-lg mt-2"
                  v-if="
                    userData.role != 'employee' && userData.role != 'leader'
                  "
                >
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="isCollapseVisibleFFC = !isCollapseVisibleFFC"
                    >
                      <img
                        src="../../../assets/images/Admin/app.png"
                        alt="application"
                        class="pl-3 py-1"
                      />

                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">
                            Future Fit Corporate
                          </p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleFFC"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>

                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleFFC"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in ffcCollapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- Gallery -->
                <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div class="flex items-center cursor-pointer gap-2">
                      <!-- <feather-icon
                        icon="HeartIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon> -->
                      <img
                        src="../../../assets/images/Admin/community1.png"
                        alt="community"
                        class="pl-3 py-1"
                      />
                      <div class="w-full">
                        <div class="ml-2 my-auto">
                          <a href="/gallery">
                            <p class="font-semibold text-base">Gallery</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>
                <!-- HEART OF CARE -->
                <div
                  class="rounded-lg mt-2"
                  v-if="userData.role != 'leader' && userData.role != 'intern'"
                >
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseHeartOfCare = !isCollapseHeartOfCare
                      "
                    >
                      <img
                        src="../../../assets/images/Admin/app.png"
                        alt="Heartofcare"
                        class="pl-3 py-1"
                      />

                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Heart Of Care</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseHeartOfCare"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>

                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseHeartOfCare"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in HeartOfCareCollapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- Home -->
                <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisibleannouncement =
                          !isCollapseVisibleannouncement
                      "
                      @click="pageCategory"
                    >
                      <img
                        src="../../../assets/images/Admin/home1.png"
                        alt="home"
                        class="pl-3 py-1"
                      />
                      <!-- <feather-icon
                        icon="FilePlusIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon> -->
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Home</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleannouncement"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleannouncement"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in announcementcollsapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- Manage Users -->
                <b-card class="cardbody-pl border-0" no-body>
                  <div
                    class="flex items-center cursor-pointer hover:bg-gray-50 py-1 px-1 mt-3 rounded-lg"
                    v-for="(item, index) in menuOption"
                    :key="'item-' + index"
                    @click="handleClick(item)"
                    :class="{
                      'bg-f4f5f6 text-white rounded-lg':
                        item.route === currentRoute.currentRoute.name,
                    }"
                  >
                    <feather-icon
                      :icon="item.iconB"
                      class="cursor-pointer p-3 text-primary icon-size-left"
                      :class="{
                        ' text-primary':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    ></feather-icon>

                    <div class="ml-2">
                      <p
                        class="font-semibold text-base"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      >
                        {{ item.textB }}
                      </p>
                    </div>
                  </div>
                </b-card>
                <!-- Medical Cancer -->
                <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div class="flex items-center cursor-pointer gap-2">
                      <img
                        src="../../../assets/images/Admin/community1.png"
                        alt="community"
                        class="pl-3 py-1"
                      />
                      <div class="w-full">
                        <div class="ml-2 my-auto">
                          <a href="/admin/medical_faq">
                            <p class="font-semibold text-base">Medical FAQ</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>
                <!-- <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div class="flex items-center cursor-pointer gap-2">
                      <img
                        src="../../../assets/images/Admin/community1.png"
                        alt="community"
                        class="pl-3 py-1"
                      />
                      <div class="w-full">
                        <div class="ml-2 my-auto">
                          <a href="/admin/medical_cancer">
                            <p class="font-semibold text-base">
                              Medical Cancer
                            </p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div> -->
                <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisibleMedicalCancer =
                          !isCollapseVisibleMedicalCancer
                      "
                    >
                      <img
                        src="../../../assets/images/Admin/community1.png"
                        alt="community"
                        class="pl-3 py-1"
                      />
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">
                            Medical Condition
                          </p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleMedicalCancer"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleMedicalCancer"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in madicalCancerCollapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- Shops & Services -->
                <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisibleaffiliate = !isCollapseVisibleaffiliate
                      "
                      @click="pageCategory"
                    >
                      <img
                        src="../../../assets/images/shopping-cart.png"
                        alt="page"
                        class="pl-1 py-1"
                      />

                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">
                            Shops & Services
                          </p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleaffiliate"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleaffiliate"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in affiliatecollapse"
                      :key="'item-' + index"
                      @click="item.text3 !== 'Home' ? handleClick(item) : ''"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                      <b-collapse
                        id="collapse-2"
                        class="bg-white px-2"
                        v-if="item.text3 === 'Home'"
                        :visible="isCollapseVisibleannouncement"
                      >
                        <div
                          class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                          v-for="(item, index) in announcementcollsapse"
                          :key="'item-' + index"
                          @click="handleClick(item)"
                          :class="{
                            'bg-f4f5f6 text-white rounded-lg':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          <feather-icon
                            :icon="item.icon3"
                            class="cursor-pointer p-3 text-primary icon-size-left"
                            :class="{
                              ' text-primary':
                                item.route === currentRoute.currentRoute.name,
                            }"
                          ></feather-icon>
                          <div class="ml-2">
                            <p
                              class="font-semibold text-base"
                              :class="{
                                ' text-primary':
                                  item.route === currentRoute.currentRoute.name,
                              }"
                            >
                              {{ item.text3 }}
                            </p>
                          </div>
                        </div>
                      </b-collapse>
                    </div>
                  </b-collapse>
                </div>
                <!-- --------------------------------------------------------Subsciption---------------------------------------------------------------- -->
                <div
                  class="rounded-lg mt-2"
                  v-if="
                    userData.role != 'employee' && userData.role != 'leader'
                  "
                >
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisibleSubsciption =
                          !isCollapseVisibleSubsciption
                      "
                    >
                      <img
                        src="../../../assets/images/Admin/app.png"
                        alt="application"
                        class="pl-3 py-1"
                      />

                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Subscription</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleSubsciption"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>

                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleSubsciption"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in SubscriptionCollapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text10 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- Vendor -->
                <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisibleVendor = !isCollapseVisibleVendor
                      "
                    >
                      <!-- <feather-icon
                        icon="HeartIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon> -->
                      <img
                        src="../../../assets/images/Admin/community1.png"
                        alt="community"
                        class="pl-3 py-1"
                      />
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Vendor</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleVendor"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                          <!-- abc -->
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleVendor"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in vendorcollapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text11 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div>
                <!-- <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div class="flex items-center cursor-pointer gap-2">
                      <feather-icon
                        icon="HeartIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <img
                        src="../../../assets/images/Admin/community1.png"
                        alt="community"
                        class="pl-3 py-1"
                      />
                      <div class="w-full">
                        <div class="ml-2 my-auto">
                          <a href="/admin/campaign">
                            <p class="font-semibold text-base">Campaign</p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div> -->
                <!-- <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer"
                      @click.stop="
                        isCollapseVisiblepages = !isCollapseVisiblepages
                      "
                      @click="pageCategory"
                    >
                      <feather-icon
                        icon="FilePlusIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Pages</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisiblepages"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisiblepages"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in pagescollsapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div> -->

                <!-- <div class="rounded-lg mt-2">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer"
                      @click.stop="
                        isCollapseVisiblesettingp = !isCollapseVisiblesettingp
                      "
                    >
                      <feather-icon
                        icon="SettingsIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Settings</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisiblesettingp"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisiblesettingp"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in settingcollsapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div> -->

                <!-- <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer gap-2"
                      @click.stop="
                        isCollapseVisibleservices = !isCollapseVisibleservices
                      "
                    >
                      <img
                        src="../../../assets/images/Admin/service1.png"
                        alt="service"
                        class="pl-3 py-1"
                      />
                      <feather-icon
                        icon="FilePlusIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon> 
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Services</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleservices"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleservices"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in servicescollsapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div> -->

                <!-- <div class="rounded-lg mt-2" v-if="userData.role != 'employee'">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer"
                      @click.stop="
                        isCollapseVisibleSpecialized =
                          !isCollapseVisibleSpecialized
                      "
                    >
                      <feather-icon
                        icon="BookOpenIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Specialized</p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisibleSpecialized"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>

                
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisibleSpecialized"
                  >
                    <div
                      class="flex items-center cursor-pointer rounded-lg hover:bg-gray-50 mt-0-5"
                      v-for="(item, index) in specializedCollapse"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div> -->

                <!-- <div class="rounded-lg mt-2" v-if="userData.role == 'admin'">
                  <b-card
                    no-body
                    @click="isshowspecializedcategory"
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div class="flex items-center cursor-pointer gap-2">
                      <img
                        src="../../../assets/images/Admin/caregiver1.png"
                        alt="caregiver"
                        class="pl-3 py-1"
                      />
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">Care Assistance</p>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div> -->

                <!-- -------------------------------------------------------------------------------------- -->
                <!-- <div class="rounded-lg mt-2" v-if="userData.role != 'employee'">
                  <b-card
                    no-body
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                    @click="showPushNotification"
                  >
                    <div class="flex items-center cursor-pointer">
                      <feather-icon
                        icon="BookOpenIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">
                            Push Notification
                          </p>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div> -->
                <!-- <div class="rounded-lg mt-2">
                  <b-card
                    no-body
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                    @click="showCorporatebooking"
                  >
                    <div class="flex items-center cursor-pointer">
                      <feather-icon
                        icon="BookOpenIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">
                            Corporate Booking
                          </p>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>

                <div class="rounded-lg mt-2">
                  <b-card
                    no-body
                    @click="showCompanydashboard"
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div class="flex items-center cursor-pointer">
                      <feather-icon
                        icon="BookOpenIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">
                            Company Dashboard
                          </p>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>

                 <div class="rounded-lg mt-2">
                  <b-card
                    no-body
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                    @click="showCorporatebooking"
                  >
                    <div class="flex items-center cursor-pointer">
                      <feather-icon
                        icon="BookOpenIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">
                            Corporate Booking
                          </p>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div> -->

                <!-- <div class="rounded-lg mt-2">
                  <b-card
                    no-body
                    @click="showCompanydashboard"
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div class="flex items-center cursor-pointer">
                      <feather-icon
                        icon="BookOpenIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">
                            Company Dashboard
                          </p>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div> -->

                <!-- <b-card class="cardbody-pl  mt-2 border-0">
                  <div
                    class="flex items-center cursor-pointer hover:bg-gray-50 py-1 rounded-lg"
                    v-for="(item, index) in Marketing"
                    :key="'item-' + index"
                    @click="handleClick(item)"
                    :class="{
                      'bg-f4f5f6 text-white rounded-lg':
                        item.route === currentRoute.currentRoute.name
                    }"
                  >
                    <feather-icon
                      :icon="item.iconMA"
                      class="cursor-pointer p-3 text-primary  icon-size-left"
                      :class="{
                        ' text-primary':
                          item.route === currentRoute.currentRoute.name
                      }"
                    ></feather-icon>

                    <div class="ml-2">
                      <p
                        class="font-semibold text-base"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name
                        }"
                      >
                        {{ item.textMA }}
                      </p>
                    </div>
                  </div>
                </b-card> -->

                <!-- <div class="rounded-lg mt-2">
                  <b-card
                    no-body
                    v-b-toggle.collapse-2
                    class="cardbody-pl border-0 hover:bg-gray-50 py-1"
                  >
                    <div
                      class="flex items-center cursor-pointer"
                      @click.stop="
                        isCollapseVisiblemarket = !isCollapseVisiblemarket
                      "
                    >
                      <feather-icon
                        icon="CodesandboxIcon"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                      ></feather-icon>
                      <div class="flex w-full justify-between">
                        <div class="ml-2 my-auto">
                          <p class="font-semibold text-base">
                            Marketing Communication
                          </p>
                        </div>
                        <div class="flex">
                          <feather-icon
                            icon="ChevronDownIcon"
                            class="cursor-pointer icon-size-left"
                            v-if="!isCollapseVisiblemarket"
                          ></feather-icon>
                          <feather-icon
                            icon="ChevronUpIcon"
                            class="cursor-pointer icon-size-left"
                            v-else
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                  </b-card>
                  <b-collapse
                    id="collapse-2"
                    class="bg-white px-2"
                    :visible="isCollapseVisiblemarket"
                  >
                    <div
                      class="
                        flex
                        items-center
                        cursor-pointer
                        rounded-lg
                        hover:bg-gray-50
                        mt-0-5
                      "
                      v-for="(item, index) in Marketing"
                      :key="'item-' + index"
                      @click="handleClick(item)"
                      :class="{
                        'bg-f4f5f6 text-white rounded-lg':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    >
                      <feather-icon
                        :icon="item.icon3"
                        class="cursor-pointer p-3 text-primary icon-size-left"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      ></feather-icon>
                      <div class="ml-2">
                        <p
                          class="font-semibold text-base"
                          :class="{
                            ' text-primary':
                              item.route === currentRoute.currentRoute.name,
                          }"
                        >
                          {{ item.text3 }}
                        </p>
                      </div>
                    </div>
                  </b-collapse>
                </div> -->

                <!-- <b-card class="cardbody-pl mt-2 border-0" no-body>
                  <div
                    class="
                      flex
                      items-center
                      cursor-pointer
                      hover:bg-gray-50
                      py-1
                      rounded-lg
                    "
                    v-for="(item, index) in myacc"
                    :key="'item-' + index"
                    @click="handleClick(item)"
                    :class="{
                      'bg-f4f5f6 text-white rounded-lg':
                        item.route === currentRoute.currentRoute.name,
                    }"
                  >
                    <feather-icon
                      icon="UserIcon"
                      class="cursor-pointer p-3 text-primary icon-size-left"
                      :class="{
                        ' text-primary':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    ></feather-icon>

                    <div class="ml-2">
                      <p
                        class="font-semibold text-base"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      >
                        {{ item.textmyacc }}
                      </p>
                    </div>
                  </div>
                </b-card> -->

                <!-- <div class="rounded-lg mt-2">
            <b-card v-b-toggle.collapse-2 class="cardbody-pl  border-0">
              <div
                class="flex items-center cursor-pointer "
                @click.stop="isCollapseVisibleB = !isCollapseVisibleB"
              >
                <feather-icon
                  icon="ShoppingCartIcon"
                  class="cursor-pointer p-3 text-primary"
                ></feather-icon>
                <div class="flex w-full justify-between">
                  <div class="ml-2 my-auto ">
                    <p class="font-semibold text-lg ">
                      Builder
                    </p>
                  </div>
                  <div class="flex">
                    <feather-icon
                      icon="ChevronDownIcon"
                      class="cursor-pointer w-4 h-4"
                      v-if="!isCollapseVisibleB"
                    ></feather-icon>
                    <feather-icon
                      icon="ChevronUpIcon"
                      class="cursor-pointer w-4 h-4"
                      v-else
                    ></feather-icon>
                  </div>
                </div>
              </div>
            </b-card>
            <b-collapse
              id="collapse-2"
              class="bg-white p-2"
              :visible="isCollapseVisibleB"
            >
              <div
                class="flex items-center cursor-pointer rounded-lg"
                v-for="(item, index) in Builder"
                :key="'item-' + index"
                @click="handleClick(item)"
                :class="{
                  'bg-f4f5f6 text-white rounded-lg':
                    item.route === currentRoute.currentRoute.name
                }"
              >
                <feather-icon
                  :icon="item.iconB"
                  class="cursor-pointer p-3 text-primary"
                  :class="{
                    ' text-primary':
                      item.route === currentRoute.currentRoute.name
                  }"
                ></feather-icon>
                <div class="ml-2">
                  <p
                    class="font-semibold text-lg "
                    :class="{
                      ' text-primary':
                        item.route === currentRoute.currentRoute.name
                    }"
                  >
                    {{ item.textB }}
                  </p>
                </div>
              </div>
            </b-collapse>
          </div> -->

                <!-- <b-card class="cardbody-pl mt-2 border-0" no-body>
                  <div
                    class="
                      flex
                      items-center
                      cursor-pointer
                      hover:bg-gray-50
                      py-1
                      rounded-lg
                    "
                    v-for="(item, index) in builder"
                    :key="'item-' + index"
                    @click="handleClick(item)"
                    :class="{
                      'bg-f4f5f6 text-white rounded-lg ':
                        item.route === currentRoute.currentRoute.name,
                    }"
                  >
                    <feather-icon
                      :icon="item.iconB"
                      class="cursor-pointer p-3 text-primary icon-size-left"
                      :class="{
                        ' text-primary':
                          item.route === currentRoute.currentRoute.name,
                      }"
                    ></feather-icon>

                    <div class="ml-2">
                      <p
                        class="font-semibold text-base"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name,
                        }"
                      >
                        {{ item.textB }}
                      </p>
                    </div>
                  </div>
                </b-card> -->

                <!-- <b-card class="cardbody-pl rounded-lg mt-2 py-1">
                  <div
                    class="flex items-center cursor-pointer"
                    v-for="(item, index) in contactus"
                    :key="'item-' + index"
                    @click="handleClick(item)"
                    :class="{
                      '': item.route === currentRoute.currentRoute.name
                    }"
                  >
                    <feather-icon
                      :icon="item.iconCUs"
                      class="cursor-pointer p-3 text-primary icon-size-left"
                      :class="{
                        ' text-primary':
                          item.route === currentRoute.currentRoute.name
                      }"
                    ></feather-icon>

                    <div class="ml-2">
                      <p
                        class="font-semibold text-base"
                        :class="{
                          ' text-primary':
                            item.route === currentRoute.currentRoute.name
                        }"
                      >
                        {{ item.textCUs }}
                      </p>
                    </div>
                  </div>
                </b-card> -->
                <!-- <div class="bg-purple py-2 px-4 flex fixed bottom-0 ">
                <feather-icon
                  icon="PhoneIcon"
                  class="cursor-pointer p-3 text-white icon-size-left"
                ></feather-icon>

                <div class="text-center mx-auto">
                  <p class="font-semibold text-base text-white">
                    Contact Us
                  </p>
                </div>
              </div> -->
              </div>
              <!-- <div class=" fixed bottom-0 w-full">
              <base-button
                block
                type="primary"
                class="rounded-none font-semibold w-full"
                >SUBMIT</base-button
              >
            </div> -->
            </div>
          </div>
        </div>
        <!-- <div class="absolute bg-design8">
          <img
            src="../../../assets/images/dots.svg"
            alt="bg-polygon"
            class="h-full w-full mt-30px"
          />
        </div> -->

        <div class="md:w-4/5 w-full md:pl-3">
          <router-view> </router-view>
        </div>

        <div class="absolute bg-design3">
          <img
            src="@/views/admin/layouts/image/Polygon 9.svg"
            alt="bg-polygon"
            class="h-150px"
          />
        </div>
        <!-- <div class="w-1/5 pl-4 h-83vh bg-white">
          <div class="w-full p-2 rounded-xl">
            <div class="">
              <div
                class="flex items-center cursor-pointer"
                v-for="(item, index) in plan"
                :key="'item-' + index"
                @click="handleClick(item)"
                :class="{
                  '': item.route === currentRoute.currentRoute.name
                }"
              >
                <div
                  class="rounded-full flex justify-center bg-primary items-center h-star"
                >
                  <feather-icon
                    :icon="item.planicon"
                    class="cursor-pointer p-3 text-white"
                    :class="{
                      ' text-primary':
                        item.route === currentRoute.currentRoute.name
                    }"
                  ></feather-icon>
                </div>

                <div class="ml-4">
                  <p
                    class="font-semibold text-base"
                    :class="{
                      ' text-primary':
                        item.route === currentRoute.currentRoute.name
                    }"
                  >
                    {{ item.planname }}
                  </p>
                  <base-button
                    filled
                    type="success"
                    class="flex py-0-5  px-2"
                    @click="addBanner"
                  >
                    <feather-icon
                      icon="UploadIcon"
                      class="mr-1 h-18w-18"
                    ></feather-icon
                    ><a class="buttontext">Upgrade</a>
                  </base-button>
                </div>
              </div>
            </div>
            <div class="mt-2">
              <div class="py-1 flex">
                <feather-icon
                  icon="UploadIcon"
                  class="mr-1 my-auto"
                ></feather-icon>
                <p class="ml-4">Upgrade</p>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import "../scss/Index.scss";
import { mapState } from "vuex";
export default {
  data() {
    return {
      menus: [
        {
          icon: "ChevronRightIcon",
          text: "Banner",
          route: "admin-addbanner",
        },
        {
          icon: "ChevronRightIcon",
          text: "Category",
          route: "admin-addcategory",
        },
        {
          icon: "BookIcon",
          text: "Coupon Management",
          route: "e-commerce-admin-couponmanagement",
        },
        {
          icon: "ChevronRightIcon",
          text: "Customer Management",
          route: "customer-management",
        },
        {
          icon: "ChevronRightIcon",
          text: "Dashboard",
          route: "admin-home",
        },
        {
          icon: "ChevronRightIcon",
          text: "Integrations",
          route: "integrations",
        },
        {
          icon: "ChevronRightIcon",
          text: "Logo",
          route: "logo",
        },
        {
          icon: "ChevronRightIcon",
          text: "Menu",
          route: "admin-menu",
        },
        {
          icon: "ChevronRightIcon",
          text: "Order Management",
          route: "order-management",
        },
        {
          icon: "ChevronRightIcon",
          text: "Page",
          route: "admin-page",
        },
        {
          icon: "ChevronRightIcon",
          text: "Product",
          route: "admin-addproduct",
        },
        {
          icon: "ChevronRightIcon",
          text: "Sales Report",
          route: "admin-reports",
        },
        {
          icon: "ChevronRightIcon",
          text: "Sub-category",
          route: "e-commerce-admin-addsubcategory",
        },
        {
          icon: "ChevronRightIcon",
          text: "Tags",
          route: "admin-addtags",
        },
        {
          icon: "ChevronRightIcon",
          text: "Taxes",
          route: "admin-taxes",
        },
        {
          icon: "ChevronRightIcon",
          text: "Contact Us",
          route: "contact-us",
        },
      ],
      collapse: [
        {
          icon2: "ChevronRightIcon",
          text2: "Category Commission",
          route: "e-commerce-admin-commission",
        },
        {
          icon2: "ChevronRightIcon",
          text2: "Coupon Code",
          route: "e-commerce-admin-couponcode",
        },
        {
          icon2: "ChevronRightIcon",
          text2: "Custom Duty",
          route: "custom-duty",
        },
        {
          icon2: "ChevronRightIcon",
          text2: "Manage Seller Review",
          route: "seller-review",
        },
        {
          icon2: "ChevronRightIcon",
          text2: "Shipway Integrations",
          route: "shipway-integration",
        },
        {
          icon2: "ChevronRightIcon",
          text2: "Store Listing",
          route: "e-commerce-admin-vendorlisting",
        },
        {
          icon2: "ChevronRightIcon",
          text2: "Store Transactions",
          route: "e-commerce-admin-vendortransactions",
        },
      ],
      plan: [
        {
          planname: "Hello, Admin",
          planicon: "StarIcon",
          route: "admin-subscriberplan",
        },
      ],
      settingcollsapse: [
        {
          icon3: "ChevronRightIcon",
          text3: "Logo",
          route: "logo",
        },
      ],

      announcementcollsapse: [
        {
          icon3: "ChevronRightIcon",
          text3: "About Us",
          route: "homepage-aboutus",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Announcement",
          route: "announcement",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "HomePage Banner",
          route: "homePageBanner",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Partner",
          route: "/admin/partners",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Testimonial",
          route: "testimonial",
        },
        // {
        //   icon3: "ChevronRightIcon",
        //   text3: "Future Fit Corporates",
        //   route: "admin-ffc",
        // },
      ],
      ffcCollapse: [
        {
          icon3: "ChevronRightIcon",
          text3: "Banner",
          route: "ffc-banner",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Corporate Event Registeration",
          route: "ffc-registeration",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "FFC Form",
          route: "admin-ffc",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "FFC Podcast",
          route: "ffc-podcasts",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Future Trends",
          route: "future-trend",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Hub",
          route: "ffc-hub",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Partners",
          route: "ffc-partner",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Testimonial",
          route: "ffc-testimonial",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Transformative Impact",
          route: "ffc-review",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Well-being Initiatives",
          route: "well-being",
        },
      ],

      aboutUsCollapse: [
        {
          icon3: "ChevronRightIcon",
          text3: "Banner",
          route: "aboutus-banner",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Main",
          route: "aboutus-main",
        },
      ],
      affiliatecollapse: [
        {
          icon3: "ChevronRightIcon",
          text3: "Banner",
          route: "admin-banner",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Brand",
          route: "admin-brand",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Order Details",
          route: "admin-mis",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Products",
          route: "affiliate-products",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Service Categories",
          route: "admin-exclusive",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Service Provider",
          route: "admin-specializedcaregiver",
        },
      ],
      pagescollsapse: [
        {
          icon3: "ChevronRightIcon",
          text3: "About Us",
          route: "about-panel",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Author",
          route: "author",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Blog",
          route: "blogs",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Careers",
          route: "careers-panel",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Doctor",
          route: "doctor",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Events",
          route: "events-panel",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "News",
          route: "news-panel",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Playlist Category",
          route: "playlist-category",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Podcast Category",
          route: "podcast-category",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Podcast",
          route: "podcasts",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Quotes",
          route: "cms-quotes",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Request Form",
          route: "playlist-form",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Regulation,Policies & Papers",
          route: "regulation-policies",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "ToolKits",
          route: "selfhelp",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Tag",
          route: "admin-tag",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "FOCGS",
          route: "friends-updates",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Video Playlist",
          route: "admin-playlist",
        },
      ],
      donatecollsapse: [
        // {
        //   icon3: "ChevronRightIcon",
        //   text3: "Gratitude",
        //   route: "gratitude",
        // },
        {
          icon3: "ChevronRightIcon",
          text3: "Donors",
          route: "donor",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Wishes",
          route: "wishes",
        },
      ],
      servicescollsapse: [
        // {
        //   icon3: "ChevronRightIcon",
        //   text3: "Banner",
        //   route: "admin-banner",
        // },
        // {
        //   icon3: "ChevronRightIcon",
        //   text3: "Service Categories",
        //   route: "admin-exclusive",
        // },
        {
          icon3: "ChevronRightIcon",
          text3: "Service Offerings",
          route: "admin-partnership",
        },
        // {
        //   icon3: "ChevronRightIcon",
        //   text3: "Curated Products & Services",
        //   route: "admin-offers",
        // },
      ],
      vendorcollapse: [
        {
          icon3: "ChevronRightIcon",
          text11: "Products",
          route: "vendor-products",
        },
        {
          icon3: "ChevronRightIcon",
          text11: "Vendor Details",
          route: "vendor-details",
        },
      ],
      socialcollapse: [
        // {
        //    icon3: "ChevronRightIcon",
        //   text3: "User ",
        //   route: "user",
        //   },
        {
          icon3: "ChevronRightIcon",
          text3: "Channel",
          route: "channel",
        },
        // {
        //   icon3: "ChevronRightIcon",
        //   text3: "Communication",
        //   route: "campaign-list"
        // },
        {
          icon3: "ChevronRightIcon",
          text3: "Posts",
          route: "posts",
        },

        // {
        // icon3: "ChevronRightIcon",
        //  text3: "Analytics",
        // route: "admin-analyticss",
        //  },
      ],
      campaigncollapse: [
        {
          icon3: "ChevronRightIcon",
          text3: "Home",
          route: "aboutcampaign-banner",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Campaigns",
          route: "campaign-home",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Banner",
          route: "campaign",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Partners",
          route: "campaign-partner",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Partner Reference",
          route: "campaign-reference",
        },
      ],
      elearningCollapse: [
        // {
        //   icon3: "ChevronRightIcon",
        //   text3: "Corporate Booking",
        //   route: "admin-corporate",
        // },
        // {
        //   icon3: "ChevronRightIcon",
        //   text3: "Role Management",
        //   route: "admin-rolemanagement",
        // },
      ],
      SubscriptionCollapse: [
        {
          icon3: "ChevronRightIcon",
          text10: "Coupon Management",
          route: "e-commerce-admin-couponmanagement",
        },
        {
          icon3: "ChevronRightIcon",
          text10: "Features",
          route: "feature",
        },
        {
          icon3: "ChevronRightIcon",
          text10: "Plan",
          route: "admin-plan",
        },
        {
          icon3: "ChevronRightIcon",
          text10: "User Details",
          route: "subscription-user",
        },
      ],
      CoachCollapse: [
        {
          icon3: "ChevronRightIcon",
          text3: "Announcement",
          route: "admin-announce",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Brochure",
          route: "admin-brochure",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Session Dates",
          route: "admin-sessiondates",
        },
      ],
      ApplicationCollapse: [
        {
          icon3: "ChevronRightIcon",
          text3: "Get App",
          route: "getApp",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Mantras",
          route: "admin-mantras",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Meditation",
          route: "meditation",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Push Notification",
          route: "admin-push",
        },
      ],
      HeartOfCareCollapse: [
        {
          icon3: "ChevronRightIcon",
          text3: "Artworks",
          route: "admin-artworks",
        },
      ],

      // NotificationCollapse: [
      //   {
      //     icon3: "ChevronRightIcon",
      //     text3: "Push Notification",
      //     route: "admin-push",
      //   },
      // ],

      specializedCollapse: [
        {
          icon3: "ChevronRightIcon",
          text3: "Corporate Booking",
          route: "admin-corporate",
        },
        // {
        //   icon3: "ChevronRightIcon",
        //   text3: "Role Management",
        //   route: "admin-rolemanagement",
        // },
      ],

      Marketing: [
        {
          icon3: "ChevronRightIcon",
          text3: "Dashboard",
          route: "campaign-list",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "E-mail",
          route: "e-mail",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Group",
          route: "group",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Reports",
          route: "reports",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Settings",
          route: "setting",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "SMS",
          route: "campaign-sms",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Transactions",
          route: "transactions",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Voiceblast",
          route: "voiceBlast",
        },
      ],

      // Marketing: [
      //   {
      //     iconMA: "Share2Icon",
      //     textMA: "Marketing Communication",
      //     route: "campaign-list"
      //   }
      // ],
      contactus: [
        {
          iconCUs: "PhoneIcon",
          textCUs: "Contact Us",
          route: "contact-us",
        },
      ],
      myacc: [
        {
          textmyacc: "Setting",
          route: "myaccount",
        },
      ],
      madicalCancerCollapse: [
        {
          icon3: "ChevronRightIcon",
          text3: "Affiliate URL",
          route: "/admin/medical-affiliate-url",
        },
        {
          icon3: "ChevronRightIcon",
          text3: "Reference Link",
          route: "/admin/medical_cancer",
        },
      ],
      categoryId: "",
      // builder: [
      // {
      // iconB: "GridIcon",
      // textB: "Builder",
      // route: "scope",
      // },

      // ],
      menuOption: [
        // {
        //   iconB: "UsersIcon",
        //   textB: "Manage Users",
        //   route: "user",
        // },
      ],
      isCollapseVisibleVendor: false,
      isCollapseVisible: false,
      isCollapseVisiblesocial: false,
      isCollapseVisiblecampaign: false,
      isCollapseVisibleEcom: false,
      isCollapseVisibleB: false,
      isCollapseVisiblemarket: false,
      isCollapseVisiblesettingp: false,
      isCollapseVisiblepages: false,
      isCollapseVisibledonate: false,
      isCollapseVisibleannouncement: false,
      isCollapseVisibleSubsciption: false,
      isCollapseVisibleFFC: false,
      isCollapseVisibleAboutUs: false,
      isCollapseVisibleaffiliate: false,
      isCollapseVisibleElearning: false,
      isCollapseVisibleCoach: false,
      isCollapseVisibleApplication: false,
      isCollapseHeartOfCare: false,
      isCollapseVisibleNotification: false,
      isCollapseVisibleMedicalCancer: false,
      isCollapseVisibleCorporateBooking: false,
      isCollapseVisibleservices: false,
      isCollapseVisibleSpecialized: false,
    };
  },

  computed: {
    currentRoute() {
      return this.$router;
    },
    isEmployee() {
      return (
        this.user && this.user._id != null && this.user.role === "employee"
      );
    },
    ...mapState("auth", ["userData"]),
    ...mapState("cms", ["pageCategories"]),
  },

  methods: {
    handleClick({ route }) {
      this.$router.push({ name: route });
      this.pageCategories.forEach((element) => {
        if (element.route == route) {
          this.categoryId = element._id;
          this.$store.dispatch("cms/getfilterbycategory", {
            categoryPage: element._id,
          });
          this.$store.dispatch("cms/getTagsbyCategory", {
            categoryPage: element._id,
          });
          this.$store.commit("cms/SET_SELECTEDPAGECATEGORY", {
            id: element._id,
            name: element.name,
          });
          this.$store.dispatch("cms/getpagebycategory", {
            id: element._id,
          });
        }
      });
    },
    async pageCategory() {
      await this.$store.dispatch("cms/getPageCategories");
    },
    addRoutes() {
      if (this.userData.role != "student") {
        this.elearningCollapse.splice(3, 0, {
          text3: "Courses",
          icon3: "ChevronRightIcon",
          route: "admin-coursesdetails",
        });
      }
      if (this.userData.role == "admin" || this.userData.role == "intern") {
        if (this.userData.role != "intern") {
          this.menuOption.push({
            iconB: "UsersIcon",
            textB: "Manage Users",
            route: "user",
          });
        }
        this.elearningCollapse.splice(
          4,
          0,
          {
            icon3: "ChevronRightIcon",
            text3: "Authors",
            route: "admin-trainersDashboard",
          },
          {
            icon3: "ChevronRightIcon",
            text3: "Course Categories",
            route: "admin-training",
          }
        );
      }
      if (this.userData.role == "employee") {
        this.$router.push({ name: "admin-dashboard" });
      }
    },
    showCorporatebooking() {
      this.$router.push({ name: "admin-corporateBooking" });
    },
    showDonorTable() {
      this.$router.push({ name: "donor" });
    },
    showPushNotification() {
      this.$router.push({ name: "admin-push" });
    },
    showCompanydashboard() {
      this.$router.push({ name: "admin-dashboard" });
    },
    showaddbooking() {
      this.$router.push({ name: "admin-addbooking" });
    },
    isshowspecializedcategory() {
      this.$router.push({ name: "admin-specializedcaregiver" });
    },
  },
  mounted() {
    this.addRoutes();
  },
};
</script>

<style>
.main-auto {
  margin-left: -3rem;
  width: 250px;
  overflow: hidden;
}
.h-250px {
  height: 250px;
}
.mt-30px {
  margin-top: 30px;
}
.h-150px {
  height: 150px;
}
.zindex-1 {
  z-index: 1;
}
.h-100vh {
  height: 100vh;
}
</style>
